import { useEffect, useState } from "react";
import { authorizationService } from "../../shared/api_services/authorizationService";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import "./Home.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { HomeButtons } from "./interface";
import { useSharedState } from "../../components/services/WindowSizeService";
import JSONHandler from "../../shared/UI Components/Modals/JSONHandler/JSONHandler";
import DrawerWrapper from "../../shared/UI Components/DrawerWrapper/DrawerWrapper";
import ModalWrapper from "../../shared/UI Components/ModalWrapper/ModalWrapper";
import UpdateLicense from "../../shared/UI Components/Modals/UpdateLicense/UpdateLicense";
import SiteConfig from "../../shared/UI Components/Modals/SiteConfig/SiteConfig";
import Log from "../../shared/UI Components/Modals/Log/Log";
import AddUrl from "../../shared/UI Components/Modals/AddUrl/AddUrl";
import AddDevice from "../../shared/UI Components/Modals/AddDevice/AddDevice";
import DeviceSettings from "../../shared/UI Components/Modals/DeviceSettings/DeviceSettings";
import AddRule from "../../shared/UI Components/AddRule/AddRule";
import Rule from "../../shared/UI Components/Modals/Rule/Rule";
import Loader from "../../shared/UI Components/Loader/Loader";
import ClearOldData from "../../shared/UI Components/Modals/ClearOldData/ClearOldData";
import addDeviceImage from "../../shared/images/add-device.png";
import { alertService } from "../../shared/UI Components/Services/alertService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../shared/Utils/Utils";
const Home = () => {
    const windowSize$ = useSharedState();
    const [deviceList, setDeviceLIst] = useState<any>();
    const [urlData, setUrlData] = useState<any>();
    const [licenseDetails, setLicenseDetails] = useState<any>();
    const [readyFlag, setReadyFlag] = useState<boolean>(false);
    const [selectedButton, setSelectedButton] = useState<string>();
    const [loader, setLoader] = useState<boolean>(true);
    const [lastRefresh, setLastRefresh] = useState<any>({});
    const [buttonData, setButtonData] = useState<any>([]);
    const [editDeviceFlag, setEditDeviceFlag] = useState<boolean>(false);
    const [selectedDevice, setSelectedDevice] = useState<any>();
    const [deleteProtocolFlag, setDeleteProtocolFlag] = useState<boolean>(false);
    const [currentIndex, setCurrentIndex] = useState<number>();
    // const buttonData: any = [
    //     {
    //         "key": "JSONHandler",
    //         "label": "JSON Handler",
    //         "headerLabel": "JSON Handler"
    //     },
    //     {
    //         "key": "Normalizer",
    //         "label": "Normalizer",
    //         "headerLabel": "Normalizer",
    //         "additionalData": true
    //     },
    //     {
    //         "key": "RuleConfiguration",
    //         "label": "Rule Configuration",
    //         "headerLabel": "Rule Configuration",
    //         "additionalData": true
    //     },
    //     {
    //         "key": "UpdateLicense",
    //         "label": "Update License",
    //         "headerLabel": "Add Certificate",
    //         "headerEnhance": true
    //     },
    //     {
    //         "key": "AddDevice",
    //         "label": "Add Device",
    //         "headerLabel": "Device Information"
    //     },
    //     {
    //         "key": "AddUrl",
    //         "label": "Add Url",
    //         "headerLabel": "Device Information"
    //     },
    //     {
    //         "key": "Settings",
    //         "label": "Settings",
    //         "headerLabel": "Device Settings"
    //     },
    //     {
    //         "key": "Logs",
    //         "label": "Logs",
    //         "headerLabel": "Device Log"
    //     },
    //     {
    //         "key": "siteConfUpload",
    //         "label": "Site ConfUpload",
    //         "headerLabel": "site.conf Upload"
    //     }
    // ]

    // const defUrl = '4.8&iLens-SCN101&SCN101L_267';


    // const defUrl = localStorage?.getItem("url") !== "undefined" ? (localStorage?.getItem("url") ? localStorage?.getItem("url") : '4.8&iLens-SCN101&SCN101L_267') : '4.8&iLens-SCN101&SCN101L_267';
    // let URL_Data = defUrl?.split('&');
    // let details = {
    //     firmware_version: URL_Data?.[0],
    //     device_type: URL_Data?.[1],
    //     device_id: URL_Data?.[2],
    // };
    let details: any = getURLDataMethod();

    useEffect(() => {
        getUrlData();
        loadListOfDevicesDetected("load");
        getDeviceStatus();
        const interval = setInterval(() => {
            // loadListOfDevicesDetected("load")
            getDeviceStatus()
        }, 30000);
        return () => clearInterval(interval);
    }, [])

    // Converting the time/date into required format
    const toJSDate = (dateTime: any) => {
        let temp = new Intl.DateTimeFormat('default',
            {
                hour12: true,
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format(dateTime);
        return (temp);
    }

    // const reload = () => {
    //     // this.loadListOfDevicesDetected('update');
    //     setTimeout(() => {
    //         // this.getMetadata();
    //         loadListOfDevicesDetected('onload');
    //         setTimeout(() => {
    //             getUrlData();
    //         }, 1000);
    //     }, 1000);
    // }

    const getUrlData = async () => {
        const payload = JSON.parse(JSON.stringify(details));
        if (payload && payload['firmware_version']) {
            const device = payload['device_type']?.split('iLens-')[1];
            try {
                return await authorizationService.getUrlData("getUrlData", payload, device, payload['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body.data))
                            setUrlData(response);
                            setButtonData(response?.buttons);
                            localStorage.setItem("siteID", response?.site_id)
                            // alertService.serviceSuccessMessage("Order details received successfully");
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        setLoader(false);
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    // calling get service to access the details of the devices
    const loadListOfDevicesDetected = async (action: any) => {
        const payload = JSON.parse(JSON.stringify(details));
        if (payload && payload['firmware_version']) {
            const device = payload['device_type']?.split('iLens-')[1];
            try {
                return await authorizationService.detectedDevicesList("DetectedDevicesList", payload, device, payload['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            setDeviceLIst(res.body.data);
                            setLoader(false);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        setLoader(false);
                        noAccessMessage(res.response?.message)
                        // console.log(res.response?.message);
                        console.log(res);
                    }
                    else {
                        console.log("error");
                    }

                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const getDeviceStatus = async () => {
        const payload = JSON.parse(JSON.stringify(details));
        if (payload && payload['firmware_version']) {
            const device = payload['device_type']?.split('iLens-')[1];
            try {
                return await authorizationService.getDeviceStatus("getDeviceStatus", payload, device, payload['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            setLoader(false);
                            setLastRefresh(res.body.data);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        setLoader(false);
                        // let reqDateTime = toJSDate(new Date().getTime());
                        // setLastRefresh(reqDateTime);
                        noAccessMessage(res.response?.message)
                    }
                    else {
                        console.log("error");
                    }

                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const setActiveButton = (button: string) => {
        setSelectedButton(button);
        if (button === 'UpdateLicense') {
            getLicenseDetails();
        }
    }

    const removeActiveButton = (button: string, eve: any) => {
        if (editDeviceFlag) {
            setEditDeviceFlag(false);
        }
        loadListOfDevicesDetected("load");
        setSelectedButton("");
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    const getLicenseDetails = async () => {
        const payload = JSON.parse(JSON.stringify(details));
        payload.site_id = urlData?.site_id;
        if (payload && payload['firmware_version']) {
            const device = payload['device_type'].split('iLens-')[1];
            try {
                return await authorizationService.getLicenseDetails("GetLicenseDetails", payload, device, payload['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            setLicenseDetails(res.body);
                            setReadyFlag(true);
                            // alertService.serviceSuccessMessage("Order details received successfully");
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }

    }

    const deleteProtocol = async (index: any) => {
        if (index > -1) {
            setDeleteProtocolFlag(true);
            const payload = JSON.parse(JSON.stringify(details));
            payload["data"] = {
                "index": index
            };
            if (payload && payload['firmware_version']) {
                const device = payload['device_type']?.split('iLens-')[1];
                try {
                    return await authorizationService.deleteProtocol("deleteProtocol", payload, device, payload['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLoader(true);
                                setDeleteProtocolFlag(false);
                                setCurrentIndex(-1);
                                loadListOfDevicesDetected("load")
                                alertService?.serviceSuccessMessage(res.body.message)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            alertService?.serviceErrorMessage(res.body.message)
                            console.log("error");
                        }

                    })
                } catch (err: any) {
                    console.log(err);
                }
            }
        }
    }

    // Editing the details of existing Device
    const onEdit = (index: any) => {
        let tempSelectedDevice = deviceList[index];
        tempSelectedDevice["index"] = index;
        setSelectedDevice(tempSelectedDevice)
        setEditDeviceFlag(true);
        setSelectedButton("AddDevice");
    }

    // Deleting the existing device
    const onDelete = (index: any) => {
        setCurrentIndex(index);
        setDeleteProtocolFlag(true);
    }

    return (
        <>
            {details?.device_type &&
                <BreadCrumb currentPage={details?.device_type} deviceID={details?.device_id} firmwareVersion={details?.firmware_version} lastUpdated={lastRefresh} />
            }
            <div className="home-body">
                <div className="mx-4 my-2 row">
                    <h4 className="site-header col-md-4 col-lg-4 col-sm-12"><b>Site</b> : {urlData?.site_name}</h4>
                    <div className="col-md-8 col-lg-8 justify-content-end button-section col-sm-12">
                        {buttonData && buttonData?.map((item: any) => {
                            return (
                                <>
                                    <button disabled={item?.disabled} type="button" className="btn btn-primary m-1" onClick={() => { setActiveButton(item?.key) }}>{item?.label}</button>
                                </>
                            )
                        })}
                    </div>
                </div>
                {loader ?
                    <Loader hasError={false} styleClass="loader-page-style w-100" /> :
                    <div className="row m-1 mr-3 mb-5 mt-2">
                        {deviceList ?
                            deviceList.map((item: any, index: number) => {
                                return (
                                    <div className="col-md-4 device-list mb-sm-2 card-min-height ">
                                        <div className=" cardStyle p-0">
                                            <div className="card">
                                                <div className="type-title">
                                                    <h6 className="action-panel row m-0">
                                                        <span className="col-8 device-name" >
                                                            Device: {item.name}
                                                        </span>
                                                        <div className="toggle-content col-4 row device-name">
                                                            <div className="action_icon col-6 pointer" onClick={() => { onEdit(index) }}>
                                                                <FontAwesomeIcon icon={faPencil} />
                                                            </div>
                                                            <div className="action_icon col-6 pointer" data-toggle="tooltip" data-placement="top" title="check" onClick={() => { onDelete(index) }}>
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </div>
                                                        </div>
                                                    </h6>

                                                    <div className="row col-md-12 table-card">
                                                        <div style={{ "width": "100%" }}>
                                                            <table className="table table-bordered table-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th><b> Channel</b></th>
                                                                        <th><b>Lower Value</b></th>
                                                                        <th><b>Upper Value</b></th>
                                                                        <th><b>Parameter Name</b></th>
                                                                        {/* <th >Value</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <>
                                                                        {item?.param && item.param.map((subItem: any) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{subItem['ch']}</td>
                                                                                    <td >{subItem['l']}</td>
                                                                                    <td >{subItem['u']}</td>
                                                                                    <td>{subItem['name']}</td>
                                                                                    {/* <td >{subItem['v']}</td> */}
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                    </>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <div className="empty-div">
                                <h6>No data to be displayed. Please refresh to load data in this page.</h6>
                            </div>
                        }
                        {buttonData && deviceList && buttonData?.map((item: any) => {
                            return (
                                <>
                                    {item?.addOnDashboard &&
                                        <div className="col-md-4 device-list mb-sm-2 card-min-height"
                                            onClick={() => { setActiveButton(item?.key) }}
                                        >
                                            <div className="cardStyle p-0 no-bg">
                                                <div className="center-alignment-class">
                                                    <div className="type-title pointer mt-5">
                                                        <div className="row col-md-12 table-card mt-4">
                                                            <div style={{ "width": "100%", "height": "120px" }}>
                                                                {/* <img className="add-device-image" src={addDeviceImage} height="120px" alt="Add Device" /> */}
                                                                <FontAwesomeIcon icon={faPlus} className="add-device-image" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </>

                            )
                        })}
                    </div>
                }
                {buttonData && buttonData?.map((item: any) => {
                    return (
                        <>
                            {
                                selectedButton === item?.key &&
                                <div>
                                    {windowSize$ === "sm" || windowSize$ === "xs" ?
                                        <DrawerWrapper title={item?.headerLabel} onClose={(eve: any) => { removeActiveButton(item?.key, eve) }} data={item?.headerEnhance && licenseDetails}>
                                            <>
                                                {selectedButton === "JSONHandler" &&
                                                    <>
                                                        <JSONHandler onClose={(eve: any) => { removeActiveButton("JSONHandler", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "Normalizer" &&
                                                    <>
                                                        <Rule onClose={(eve: any) => { removeActiveButton("Normalizer", eve) }} page={item?.additionalData && "Normalizer"} />
                                                    </>
                                                }
                                                {selectedButton === "RuleConfiguration" &&
                                                    <>
                                                        <Rule onClose={(eve: any) => { removeActiveButton("RuleConfiguration", eve) }} page={item?.additionalData && "RuleConfiguration"} />
                                                    </>
                                                }
                                                {selectedButton === "UpdateLicense" &&
                                                    <>
                                                        <UpdateLicense onClose={(eve: any) => { removeActiveButton("UpdateLicense", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "AddDevice" && editDeviceFlag && deviceList &&
                                                    <div>
                                                        <AddDevice onClose={(eve: any) => { removeActiveButton("AddDevice", eve) }} data={editDeviceFlag && selectedDevice} type="edit" />
                                                    </div>
                                                }
                                                {selectedButton === "AddDevice" && !editDeviceFlag &&
                                                    <>
                                                        <AddDevice onClose={(eve: any) => { removeActiveButton("AddDevice", eve) }} type="add" />
                                                    </>
                                                }
                                                {selectedButton === "AddUrl" &&
                                                    <>
                                                        <AddUrl onClose={(eve: any) => { removeActiveButton("AddUrl", eve) }} data={urlData} />
                                                    </>
                                                }
                                                {selectedButton === "Settings" &&
                                                    <>
                                                        <DeviceSettings onClose={(eve: any) => { removeActiveButton("Settings", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "Logs" &&
                                                    <>
                                                        <Log onClose={(eve: any) => { removeActiveButton("Logs", eve) }} title={item?.headerLabel} />
                                                    </>
                                                }
                                                {selectedButton === "siteConfUpload" &&
                                                    <>
                                                        <SiteConfig onClose={(eve: any) => { removeActiveButton("siteConfUpload", eve) }} />
                                                    </>
                                                }
                                            </>
                                        </DrawerWrapper>
                                        :
                                        <ModalWrapper title={item?.headerLabel} onClose={(eve: any) => { removeActiveButton(item?.key, eve) }} data={item?.headerEnhance && licenseDetails}>
                                            <>
                                                {selectedButton === "JSONHandler" &&
                                                    <>
                                                        <JSONHandler onClose={(eve: any) => { removeActiveButton("JSONHandler", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "Normalizer" &&
                                                    <>
                                                        <Rule onClose={(eve: any) => { removeActiveButton("Normalizer", eve) }} page={item?.additionalData && "Normalizer"} />
                                                    </>
                                                }
                                                {selectedButton === "RuleConfiguration" &&
                                                    <>
                                                        <Rule onClose={(eve: any) => { removeActiveButton("RuleConfiguration", eve) }} page={item?.additionalData && "RuleConfiguration"} />
                                                    </>
                                                }
                                                {selectedButton === "UpdateLicense" &&
                                                    <>
                                                        <UpdateLicense onClose={(eve: any) => { removeActiveButton("UpdateLicense", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "AddDevice" && editDeviceFlag && deviceList &&
                                                    <div>
                                                        <AddDevice onClose={(eve: any) => { removeActiveButton("AddDevice", eve) }} data={editDeviceFlag && selectedDevice} type="edit" />
                                                    </div>
                                                }
                                                {selectedButton === "AddDevice" && !editDeviceFlag &&
                                                    <>
                                                        <AddDevice onClose={(eve: any) => { removeActiveButton("AddDevice", eve) }} type="add" />
                                                    </>
                                                }
                                                {selectedButton === "AddUrl" &&
                                                    <>
                                                        <AddUrl onClose={(eve: any) => { removeActiveButton("AddUrl", eve) }} data={urlData} />
                                                    </>
                                                }
                                                {selectedButton === "Settings" &&
                                                    <>
                                                        <DeviceSettings onClose={(eve: any) => { removeActiveButton("Settings", eve) }} />
                                                    </>
                                                }
                                                {selectedButton === "Logs" &&
                                                    <>
                                                        <Log onClose={(eve: any) => { removeActiveButton("Logs", eve) }} title={item?.headerLabel} />
                                                    </>
                                                }
                                                {selectedButton === "siteConfUpload" &&
                                                    <>
                                                        <SiteConfig onClose={(eve: any) => { removeActiveButton("siteConfUpload", eve) }} />
                                                        {/* <ClearOldData onClose={(eve: any) => { removeActiveButton("siteConfUpload", eve) }} /> */}
                                                    </>
                                                }

                                            </>
                                        </ModalWrapper>
                                    }
                                </div>
                            }
                        </>
                    )
                })}
                {
                    deleteProtocolFlag &&
                    <ModalWrapper title="Device Information" onClose={(eve: any) => { setDeleteProtocolFlag(false) }} >
                        <>
                            <div className="modal-body py-3 events-none">
                                <span className="fs-12">
                                    <h6>
                                        Are you sure want to delete....?
                                    </h6>
                                </span>
                            </div>
                            <div className="border-footer-top modal-footer justify-content-center" >
                                <div className="dis">
                                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => { setDeleteProtocolFlag(false) }}>Close</button>
                                    {
                                        <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={() => { deleteProtocol(currentIndex) }}>Delete</button>
                                    }
                                </div>
                            </div>
                        </>
                    </ModalWrapper>
                }
            </div>
        </>
    )
}
export default Home;